var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"stage",staticClass:"result-focus"},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"result-focus-main"},[_c('h3',[_vm._v("务必关注【才博】公众号进行学习！")]),_c('div',{staticClass:"result-focus-main-qrcode"},[_c('img',{staticClass:"result-focus-qr",attrs:{"src":"http://edu-wps-cn.ks3-cn-beijing.ksyun.com/static_file/pictures/qrcode/688734ea69c12c7a8ef9d8a6df5573f2.png"}})])])
}]

export { render, staticRenderFns }